import {useKeycloak} from "@react-keycloak/web";
import PropTypes from "prop-types";
import {env} from "../../../../env.js";

const HasRole = (props) => {
    const {keycloak, initialized} = useKeycloak();
    const kcRoles = keycloak?.tokenParsed?.resource_access?.[env.REALM]?.roles;

    const hasAnyRole = () =>
        initialized &&
        (!props.roles || props.roles?.some((r) => kcRoles?.includes(r)));

    const hasAllRoles = () =>
        initialized &&
        (!props.roles || props.roles?.every((r) => kcRoles?.includes(r)));

    if (props?.roles?.some((r) => Boolean(r) === false)) {
        return <></>
    } else if (!!props?.roles && props.mode === 'pass') {
        return props.children
    } else if (props.mode === 'all' && hasAllRoles()) {
        return props.children
    } else if (props.mode === 'any' && hasAnyRole()) {
        return props.children
    } else {
        return <></>
    }
}


HasRole.propTypes = {
    children: PropTypes.any.isRequired, //@komponent do wy
    roles: PropTypes.array.isRequired,//@tablica ról oczekiwanych
    mode: PropTypes.oneOf(['all', 'any', 'pass']).isRequired //@all - wszystkie role, any - przynajmniej jedna

}

export default HasRole;